window.MapsReady(($) => {

  window.THEME_MAP_MARKER = {
    url: window.THEME_OPTIONS.theme_url + '/public/svg/map_marker.svg',
    scaledSize: new google.maps.Size(22, 44),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(11, 22),
  };

  window.THEME_MAP_MARKER_ACTIVE = {
    url: window.THEME_OPTIONS.theme_url + '/public/svg/map_marker_active.svg',
    scaledSize: new google.maps.Size(22, 44),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(11, 22),
  };

});

// window.THEME_MAP_MARKER = window.THEME_OPTIONS.theme_url + '/public/svg/map_marker.svg';
// window.THEME_MAP_MARKER_ACTIVE = window.THEME_OPTIONS.theme_url + '/public/svg/map_marker_active.svg';
// window.THEME_MAP_MARKER = function(size) {
//   let color = getComputedStyle(document.querySelector('body')).getPropertyValue('--color-primary-light');

//   return {
//     // size: new google.maps.Size(30, 42),
//     // scaledSize: new google.maps.Size(30, 42),
//     // origin: new google.maps.Point(0, 0),
//     anchor: new google.maps.Point(15, 42),
//     scale: (size == 'large') ? 1.5 : 1,
//     path: "M15.0020099,0 C6.72108591,0.0088600894 0.0099696122,6.71907725 0,15 C0,25.2646389 13.4242262,40.3349859 13.9950422,40.9721292 C14.2512188,41.2574158 14.6165748,41.4203784 15,41.4203784 C15.3834252,41.4203784 15.7487812,41.2574158 16.0049578,40.9721292 C16.5757738,40.3349859 30,25.2666488 30,15 C29.9900349,6.72064442 23.2813641,0.011074519 15.0020099,0 L15.0020099,0 Z M15.0020099,22.5492429 C10.8337882,22.5492429 7.4547769,19.1702316 7.4547769,15.0020099 C7.4547769,10.8337882 10.8337882,7.4547769 15.0020099,7.4547769 C19.1702316,7.4547769 22.5492429,10.8337882 22.5492429,15.0020099 C22.5448118,19.1683948 19.1683948,22.5448118 15.0020099,22.5492429 Z",
//     fillColor: color,
//     fillOpacity: 1.0,
//     strokeColor: color,
//     strokeOpacity: 1.0,
//   };
// };

// https://snazzymaps.com/style/1243/xxxxxxxxxxx
window.THEME_MAP_STYLES = [
  {
    "featureType": "all",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "weight": "2.19"
      },
      {
        "lightness": "-5"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#fff6e9"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "gamma": "1.19"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "gamma": "0.00"
      },
      {
        "weight": "2.07"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "color": "#d5de87"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "hue": "#ffaa00"
      },
      {
        "lightness": "-77"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "hue": "#ff0000"
      },
      {
        "lightness": "100"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "lightness": "22"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "all",
    "stylers": [
      {
        "color": "#d5de87"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#d5de87"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "simplified"
      },
      {
        "lightness": "-56"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "lightness": "46"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.icon",
    "stylers": [
      {
        "lightness": "44"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#8a8e4b"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#8a8e4b"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#bccddb"
      }
    ]
  }
];
